import { createAction } from 'redux-actions';
import { reduxKey } from './constants';
import {
  PapiSettingsDeactivationInitConfirmation,
  PapiSettingsInitAccount,
  PapiSettingsInitBrowsing,
  PapiSettingsInitDeactivation,
  PapiSettingsInitGdpr,
  PapiSettingsInitGdprLink,
  PapiSettingsInitNotifications,
  PapiSettingsInitPromotion,
  PapiSettingsInitSecurity,
} from '@wix/da-papi-types';

export const action = createAction(`${reduxKey}.XXX`, () => ({}));

export const initMyAccountPage = createAction(
  `${reduxKey}.INIT_MY_ACCOUNT_PAGE`,
  (data: PapiSettingsInitAccount) => ({ data })
);

export const initBrowsingPage = createAction(
  `${reduxKey}.INIT_BROWSING_PAGE`,
  (data: PapiSettingsInitBrowsing) => ({ data })
);
export const initSecurityPage = createAction(
  `${reduxKey}.INIT_SECURITY_PAGE`,
  (data: PapiSettingsInitSecurity) => ({ data })
);
export const initNotificationsPage = createAction(
  `${reduxKey}.INIT_NOTIFICATIONS_PAGE`,
  (data: PapiSettingsInitNotifications) => ({ data })
);
export const initPromosPage = createAction(
  `${reduxKey}.INIT_PROMOS_PAGE`,
  (data: PapiSettingsInitPromotion) => ({ data })
);
export const initPersonalDataPage = createAction(
  `${reduxKey}.INIT_PERSONAL_DATA_PAGE`,
  (
    data: PapiSettingsInitGdpr & {
      emailQueryParams?: { token: string; ts: number };
      fromDeactivation?: boolean;
    }
  ) => ({ data })
);
export const initPersonalDataDownloadPage = createAction(
  `${reduxKey}.INIT_PERSONAL_DATA_DOWNLOAD_PAGE`,
  (data: PapiSettingsInitGdprLink) => ({ data })
);
export const initDeactivationPage = createAction(
  `${reduxKey}.INIT_DEACTIVATION_PAGE`,
  (data: PapiSettingsInitDeactivation & { linkSource?: string }) => ({ data })
);

export const initDeactivationConfirmationPage = createAction(
  `${reduxKey}.INIT_DEACTIVATION_CONFIRMATION_PAGE`,
  (
    data: PapiSettingsDeactivationInitConfirmation & {
      emailToken: string;
      emailTokenTs: string;
      emailLinkSource?: string;
    }
  ) => ({ data })
);

export const initDeactivationStatus = createAction(
  `${reduxKey}.INIT_DEACTIVATION_STATUS`,
  (status: {
    isDeactivated?: boolean;
    canReactivate?: boolean;
    timeUntilReactivation?: number;
  }) => ({
    status,
  })
);
